var PpcProductCategoryData = React.createContext({});
export var PpcProductCategoryDataProvider = PpcProductCategoryData.Provider;
export var PpcProductCategoryDataConsumer = PpcProductCategoryData.Consumer;
export default PpcProductCategoryData;